import { SiteDTO, SiteType } from '@luminovo/http-client';

export function hasSiteTag(site: Pick<SiteDTO, 'tags'>, siteType: SiteType): boolean {
    return site.tags.some((tag) => tag === siteType);
}

export function isSiteDefaultFor(site: Pick<SiteDTO, 'is_default_for'>, siteType: SiteType): boolean {
    return site.is_default_for.some((tag) => tag === siteType);
}
